export default __webpack_public_path__ + "static/media/grant_icon.07ffda70.svg";